import React, { useEffect, useState } from 'react';
import { MessageCircle, Users, Bot, BellRing, ScrollText } from 'lucide-react';
import { toast } from 'sonner';
import { waApi, errMsg } from '../components/whatsapp/waApi';
import { WaStatusCard } from '../components/whatsapp/WaStatusCard';
import { WaProductionReadiness } from '../components/whatsapp/WaProductionReadiness';
import { WaAccessRow } from '../components/whatsapp/WaAccessRow';
import { WaConsole } from '../components/whatsapp/WaConsole';
import { WaReports } from '../components/whatsapp/WaReports';
import { WaMessageLog } from '../components/whatsapp/WaMessageLog';
import { WaConnectionForm } from '../components/whatsapp/WaConnectionForm';

const TABS = [
  { key: 'access', label: 'Who can talk to TI', icon: Users },
  { key: 'console', label: 'Bot Console', icon: Bot },
  { key: 'reports', label: 'Push Reports', icon: BellRing },
  { key: 'log', label: 'Message Log', icon: ScrollText },
];
// Connection (Meta keys) is intentionally NOT a visible tab — open /whatsapp-bot?connection=1 as owner.

export default function WhatsAppBot() {
  const [tab, setTab] = useState('access');
  const showConnection = new URLSearchParams(window.location.search).get('connection') === '1';
  const [status, setStatus] = useState(null);
  const [data, setData] = useState({ users: [], catalog: null });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [s, a] = await Promise.all([waApi.status(), waApi.access()]);
      setStatus(s); setData(a);
    } catch (e) { toast.error(errMsg(e)); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const onSaved = (u) => setData(d => ({ ...d, users: d.users.map(x => x.id === u.id ? u : x) }));

  return (
    <div className="space-y-4" data-testid="whatsapp-bot-page">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-zinc-50 flex items-center gap-2"><MessageCircle className="text-[#25D366]" size={22} /> TI · WhatsApp Bot</h1>
          <p className="text-zinc-500 text-xs mt-0.5">One ERP brain on WhatsApp — scoped per person · writes need a YES · morning & Monday pushes</p>
        </div>
      </div>
      <WaStatusCard status={status} onRefresh={load} />
      <WaProductionReadiness status={status} onRefresh={load} />
      <div className="flex flex-wrap gap-2">
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`wa-tab-${t.key}`}
            className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-semibold transition-all ${
              tab === t.key ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'bg-zinc-900 border-zinc-800 text-zinc-400 hover:text-zinc-200'}`}>
            <t.icon size={13} /> {t.label}
          </button>
        ))}
      </div>
      {loading && <div className="text-xs text-zinc-500">Loading…</div>}
      {!loading && tab === 'access' && data.catalog && (
        <div className="space-y-3" data-testid="wa-access-list">
          <p className="text-xs text-zinc-500">Link a WhatsApp number to each ERP user, then choose what TI may answer and what it may change for them. Write actions always show a preview and wait for a <b>YES</b> on WhatsApp.</p>
          {data.users.map(u => <WaAccessRow key={u.id} user={u} catalog={data.catalog} onSaved={onSaved} />)}
        </div>
      )}
      {!loading && tab === 'console' && <WaConsole users={data.users} />}
      {!loading && tab === 'reports' && <WaReports users={data.users} />}
      {!loading && tab === 'log' && <WaMessageLog />}
      {!loading && showConnection && <WaConnectionForm onSaved={load} />}
    </div>
  );
}
